import API from '../../../constants/api';

export const FETCH_REGISTERED_MACHINE_REQUEST = '@@registeredMachine/LOAD_REGISTERED_MACHINE_REQUEST';
export const FETCH_REGISTERED_MACHINE_SUCCESS = '@@registeredMachine/FETCH_REGISTERED_MACHINE_SUCCESS';
export const FETCH_REGISTERED_MACHINE_FAILURE = '@@registeredMachine/FETCH_REGISTERED_MACHINE_FAILURE';
export const CLEAR_REGISTERED_MACHINE = '@@registeredMachine/CLEAR_REGISTERED_MACHINE';

export const fetchRegisteredMachineDetails = () => ({
    type: FETCH_REGISTERED_MACHINE_REQUEST,
});

export const clearRegisteredMachineDetails = () => ({
    type: CLEAR_REGISTERED_MACHINE,
    api: API.APP_CONFIGURATION_JSON,
});

export const addRegisteredMachineDetails = registeredMachineDetails => ({
    type: FETCH_REGISTERED_MACHINE_SUCCESS,
    registeredMachineDetails,
});
